import { Disclosure, Transition } from "@headlessui/react";
import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/react/outline";
import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { classNames } from "../../helpers";

type NestedMenuItemProps = {
  item: {
    name: string;
    href: string;
    icon: JSX.Element | any;
    className?: string;
    separate?: "top" | "bottom" | any;
    counter?: string | number;
    children?: { name: string; href: string }[];
  };
  closeSideBar?: () => void;
};
export default function NestedMenuItem({
  item,
  closeSideBar,
}: NestedMenuItemProps) {
  const { pathname } = useLocation();
  const getChildrenPath = () => {
    var isInpath = false;
    item.children?.map((pathItem) => {
      isInpath = isInpath || pathname === pathItem.href;
    });
    return isInpath;
  };
  return (
    <Disclosure as={"div"} className="w-full">
      {({ open }) => (
        <>
          <Disclosure.Button className={"w-full"}>
            <div
              className={classNames(
                !!getChildrenPath()
                  ? //   item.current
                    "bg-gray-200 text-gray-800  "
                  : "text-gray-600 hover:bg-gray-50 hover:text-gray-800  w-full",
                !!item.className && item.className,
                "group flex items-center px-2 my-1 py-2 text-sm font-medium rounded-md w-full"
              )}
            >
              <item.icon
                className={classNames(
                  // item.current
                  pathname === item.href
                    ? "text-gray-500"
                    : "text-gray-500 group-hover:text-gray-600",
                  "ltr:mr-3 rtl:ml-3 h-6 w-6"
                )}
                aria-hidden="true"
              />

              {item?.name}
              <div className="flex items-center ltr:ml-auto rtl:mr-auto">
                {!!item?.counter && (
                  <p className=" inline-flex items-center justify-center px-0.5 text-xs  bg-gray-200 w-8 h-5  rounded-full  ">
                    {item?.counter}
                  </p>
                )}
                <ChevronDownIcon
                  className={classNames(
                    open && "rotate-180",
                    "trans w-8 h-5 text-center rounded-full  transition-all"
                  )}
                />
              </div>
            </div>
          </Disclosure.Button>

          {/*
            Use the `Transition` + `open` render prop argument to add transitions.
          */}
          <Transition
            show={open}
            enter="transition duration-100 ease-out"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-75 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0"
          >
            {/*
              Don't forget to add `static` to your `Disclosure.Panel`!
            */}
            <Disclosure.Panel as="ul" className={" list-disc"}>
              {!!item.children &&
                item.children.length > 0 &&
                item.children.map((child: any, index) => {
                  return (
                    <li
                      key={`${index}_${child.name}`}
                      className={classNames(
                        pathname === child.href
                          ? //   item.current
                            "bg-gray-200 text-gray-800  "
                          : "text-gray-500 hover:bg-gray-50 hover:text-gray-800  w-full",
                        !!item.className && item.className,
                        "group flex  items-center px-2 my-2 py-2 text-xs font-medium rounded-md w-full"
                      )}
                    >
                      <Link
                        className="w-full"
                        onClick={closeSideBar}
                        to={child.href}
                      >
                        <div className="flex w-full items-center justify-between">
                          <div className="flex items-center ">
                            <div className="h-2 w-2 mx-3 rounded-full border bg-white border-gray-500"></div>
                            <h6>{child.name}</h6>
                          </div>
                          {!!child.counter && (
                            <p className=" inline-flex   ltr:mr-auto rtl:mr-auto items-center justify-center px-0.5 text-xs  bg-gray-200 w-8 h-5  rounded-full  ">
                              {child?.counter}
                            </p>
                          )}
                        </div>
                      </Link>
                    </li>
                  );
                })}
            </Disclosure.Panel>
          </Transition>
        </>
      )}
    </Disclosure>
  );
}
